import { motion } from 'framer-motion'
import Success from '@/components/Toast/success'
import Error from '@/components/Toast/error'
import { useToast } from '@chakra-ui/react'
import mixpanel from 'mixpanel-browser'
import { useState, useEffect } from 'react'
import { Spinner } from '@chakra-ui/react'
import { useRouter } from 'next/router'

interface SignUpProps {
  personType: string
}

export default function SignUp({ personType }: SignUpProps) {
  const toast = useToast()
  const [isLoading, setIsLoading] = useState(false)
  const router = useRouter()

  useEffect(() => {
    mixpanel.init('b53e4087bdeef3afa147f7eb9e37140d')
  }, [])

  return (
    <div className="flex justify-center flex-wrap gap-5 mx-5">
      <div className="relative items-center">
        <a href="https://godons.io" target="_blank" rel="noreferrer">
          <motion.button
            type="submit"
            className={`rounded-full text-xl font-bold bg-blue text-white py-[10px] px-6 hover:bg-blueHover whitespace-nowrap 
          shadow-md hover:shadow-lg ${
            isLoading ? 'opacity-0 pointer-events-none' : ''
          }`}
            whileHover={{
              scale: 1.04,
              transition: { duration: 0.1 },
            }}
            whileTap={{
              scale: 0.98,
              transition: { duration: 0.1 },
            }}
          >
            Sign Up
          </motion.button>
        </a>
        {isLoading && (
          <div
            className="absolute inset-0 flex items-center justify-center bg-blue opacity-50 rounded-full shadow-md py-[10px] px-6
          cursor-not-allowed "
          >
            <Spinner size="md" color="white" />
          </div>
        )}
      </div>
    </div>
  )
}
